// extracted by mini-css-extract-plugin
export default {"dots_container":"Loader_dots_container__ag3TC","dot":"Loader_dot__8Tb8I"};